/* ekan */
var markers = [];
var AutocompleteService;
var PlacesService;
var map;
var infowindow;
var transporteurs = {
	"Mondial Relay Point Relais": "Mondial Relay",
	"Mon Bureau de Poste": "Colissimo Bureau de Poste",
	"Mon Commercant": "Colissimo Commerçant",
  "Chrono Relais 13": "Chrono Relais"
}
var serviceTransporteurs = {
	"Mon Commercant": "Colissimo Mon Commercant",
	"Mon Bureau de Poste": "Colissimo Mon Bureau de Poste",
  "Chrono Relais 13": "Chrono Relais"
}

// Clear shipping address values
function clearShippingDatas() {
	jQuery('input[name="shipping_first_name"]').val('');
	jQuery('input[name="shipping_last_name"]').val('');
	jQuery('input[name="shipping_address_1"]').val('');
	jQuery('input[name="shipping_address_2"]').val('');
	jQuery('input[name="shipping_city"]').val('');
	jQuery('input[name="shipping_postcode"]').val('');
}

// Show/Hide ekan blocks
jQuery("#address-button").on( "click", function(e) {
		e.preventDefault();

		if(!jQuery("#address").data("place_id")){
			return;
		}
		jQuery(".ekan-block-bottom").show().addClass("loading");
		map = new google.maps.Map(document.getElementById('map'), {
			zoom: 15
		});
		infowindow = new google.maps.InfoWindow({});
		PlacesService = new google.maps.places.PlacesService(map);
		PlacesService.getDetails({
			placeId: jQuery("#address").data("place_id")
		}, function(place, status) {
			if(status === google.maps.places.PlacesServiceStatus.OK){
				map.setCenter(place.geometry.location);
				var bounds = new google.maps.LatLngBounds();
				var data = {
					action: "ekan",
					street: "",
					city: "",
					postal_code: "",
					country: "",
					ctry: ""
				};
				place.address_components.forEach(function(address_component){
					if(-1 != address_component.types.indexOf("country")){
						data.country = address_component.long_name;
						data.ctry = address_component.short_name;
						jQuery("#shipping_country").val(address_component.short_name).change();
						return;
					}
					if(-1 != address_component.types.indexOf("postal_code")){
						data.postal_code = address_component.long_name;
						return;
					}
					if(-1 != address_component.types.indexOf("street_number")){
						if(!data.street){
							data.street = "";
						}
						data.street = address_component.long_name + " " + data.street;
						data.street = data.street.trim();
						return;
					}
					if(-1 != address_component.types.indexOf("route")){
						if(!data.street){
							data.street = "";
						}
						data.street += " " + address_component.long_name;
						data.street = data.street.trim();
						return;
					}
					if(!data.city && -1 != address_component.types.indexOf("administrative_area_level_2")){
						data.city = address_component.long_name;
						return;
					}
					if(-1 != address_component.types.indexOf("locality")){
						data.city = address_component.long_name;
						return;
					}
				});
				markers.forEach(function(marker){
					marker.setMap(null);
				});
				markers = [];
				jQuery("#table-holder").empty();
				jQuery.getJSON(ajax.ajaxurl, data, function(data){
					jQuery(".ekan-block-bottom").removeClass("loading");
					if(!data.PointRelais){
						jQuery("<p></p>").appendTo("#table-holder")
							.text("Pas de résultat.");
						jQuery("<p></p>").appendTo("#table-holder")
							.text("Veuillez saisir une adresse précise (exemple : 10 rue Poussin Chartres).");
						jQuery("<p></p>").appendTo("#table-holder")
							.text("Un simple nom de ville ou une rue sans numéro ne fonctionne pas toujours.");
						jQuery("<p></p>").appendTo("#table-holder")
							.text("Si c’est bien ce que vous avez fait, il se peut que la requête ne se soit pas correctement effectuée et il faut réessayer (cliquer de nouveau sur “Chercher”).");
						jQuery("<p></p>").appendTo("#table-holder")
							.html("Si ça ne fonctionne toujours pas nous sommes à votre disposition à <a href='mailto:contact@rhumattitude.com'>contact@rhumattitude.com</a> ou au 01 75 51 46 19 pour trouver une solution avec vous.");
						return;
					}
	//				jQuery("<h1></h1>").appendTo("#table-holder").text("Choisissez un point relais");
					jQuery("<table></table>", {
						id: "addresses"
					}).appendTo("#table-holder");
					var i = 0;
					data.PointRelais.forEach(function(point){
						var transporteur = point.InfosPointRelais.serviceTransporteur;
						if(transporteurs[transporteur]){
							transporteur = transporteurs[transporteur];
						}
						if(!data.cost[transporteur]){

							return;
						}
						var cost = " - Gratuit";
						if("0" !== data.cost[transporteur]){
							cost = " - " + data.cost[transporteur] + " €";
						}
						if ('FRANCE' !== point.InfosPointRelais.pays) {
							cost = "";
						}
						var svg = '<svg width="25" height="31" viewBox="0 0 25 31" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.4002 13.9499C13.6842 13.9499 14.7252 12.909 14.7252 11.6249C14.7252 10.3409 13.6842 9.29993 12.4002 9.29993C11.1161 9.29993 10.0752 10.3409 10.0752 11.6249C10.0752 12.909 11.1161 13.9499 12.4002 13.9499Z" fill="#FF7907"/><path d="M12.4 1.55226e-08C9.13266 -0.000163354 5.99733 1.28922 3.67541 3.58791C1.3535 5.88661 0.032673 9.00882 0 12.276C0 20.7699 10.9275 30.2249 11.3925 30.6279C11.6732 30.868 12.0305 31 12.4 31C12.7694 31 13.1267 30.868 13.4075 30.6279C13.95 30.2249 24.7999 20.7699 24.7999 12.276C24.7672 9.00882 23.4464 5.88661 21.1245 3.58791C18.8026 1.28922 15.6673 -0.000163354 12.4 1.55226e-08ZM12.4 17.0499C11.327 17.0499 10.2781 16.7318 9.386 16.1357C8.49387 15.5396 7.79853 14.6923 7.38793 13.701C6.97732 12.7097 6.86989 11.6189 7.07922 10.5666C7.28854 9.51426 7.80522 8.54762 8.56392 7.78892C9.32262 7.03022 10.2893 6.51354 11.3416 6.30422C12.3939 6.0949 13.4847 6.20233 14.476 6.61293C15.4673 7.02354 16.3146 7.71887 16.9107 8.611C17.5068 9.50314 17.8249 10.552 17.8249 11.625C17.8249 13.0638 17.2534 14.4436 16.236 15.461C15.2186 16.4784 13.8388 17.0499 12.4 17.0499V17.0499Z" fill="#FF7907"/></svg>';
						var marker = new google.maps.Marker({
							position: new google.maps.LatLng(point.InfosPointRelais.latitude, point.InfosPointRelais.longitude),
							animation: google.maps.Animation.DROP,
							title: point.InfosPointRelais.nom,
							icon: { url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg), scaledSize: new google.maps.Size(25, 31) }
						});
						i++;
						setTimeout(function(){
							marker.setMap(map);
						}, i * 100);
						markers.push(marker);
						bounds.extend(new google.maps.LatLng(point.InfosPointRelais.latitude, point.InfosPointRelais.longitude));
						jQuery("<tr></tr>").appendTo("#addresses");
						var info = "N°" + point.InfosPointRelais.numeroPointRelais + "<br />"
						info += point.InfosPointRelais.nom + "<br />";
						if(-1 == ["Point Relais", "Bureau de Poste"].indexOf(point.InfosPointRelais.typePointRelais)){
							info += point.InfosPointRelais.typePointRelais + "<br />";
						}
						var serviceTransporteur = point.InfosPointRelais.serviceTransporteur;
						if(serviceTransporteurs[serviceTransporteur]){
							serviceTransporteur = serviceTransporteurs[serviceTransporteur];
						}
						if(point.InfosPointRelais.days){
							serviceTransporteur += " J+" + point.InfosPointRelais.days;
						}
						info += serviceTransporteur + "<br />";
						if("string" == typeof point.InfosPointRelais.adresse1){
							info += point.InfosPointRelais.adresse1 + "<br />";
						}
						if("string" == typeof point.InfosPointRelais.adresse2){
							info += point.InfosPointRelais.adresse2 + "<br />";
						}
						if("string" == typeof point.InfosPointRelais.adresse3){
							info += point.InfosPointRelais.adresse3 + "<br />";
						}
						if("string" == typeof point.InfosPointRelais.adresse4){
							info += point.InfosPointRelais.adresse4 + "<br />";
						}
						info += point.InfosPointRelais.codePostal + " " + point.InfosPointRelais.ville;
						jQuery("<td></td>").appendTo("#addresses tr:last").html(info);
						info += '<p><a onclick="jQuery(\'#select-office-' + i + '\').click(); return false;" href="#" class="select-office"><span>Sélectionner</span>' + cost + '</a></p>';
						marker.addListener('click', function(){
							infowindow.setContent(info);
							infowindow.open(map, marker);
						});
						var time = "";
						var days = {
							Lun: "lundi",
							Mar: "mardi",
							Mer: "mercredi",
							Jeu: "jeudi",
							Ven: "vendredi",
							Sam: "samedi",
							Dim: "dimanche"
						};
						jQuery.each(days, function(k, day){
							if(point.InfosPointRelais.periodesOuverture && point.InfosPointRelais.periodesOuverture.periodeOuverture && point.InfosPointRelais.periodesOuverture.periodeOuverture[day]){
								var s = point.InfosPointRelais.periodesOuverture.periodeOuverture[day].replace(/00:00-00:00/g, '').trim();
								if(s != ""){
									time += k + ": " + s + "<br>";
								}
							}
						});
						jQuery("<td></td>", {
							class: "time"
						}).appendTo("#addresses tr:last").html(time);
						jQuery("<a></a>", {
							href: "#",
							class: "select-office",
							id: "select-office-" + i
						}).prependTo("#addresses tr:last td.time").html(
							"<span>Sélectionner</span>" + cost
						).click(function(){
							selectOffice(point.InfosPointRelais, transporteur);
							if(!jQuery("#shipping_method").length){
								jQuery(this).closest("form").prepend('<input type="hidden" id="shipping_method" name="shipping_method_title">');
							}
							jQuery("#shipping_method").val(transporteur);
							return false;
						});
						jQuery("<td></td>", {
							class: "select-office-cell"
						}).appendTo("#addresses tr:last");
						jQuery("<a></a>", {
							href: "#",
							class: "select-office",
							id: "select-office-" + i
						}).appendTo("#addresses tr:last td:last").html(
							"<span>Sélectionner</span>" + cost
						).click(function(){
							selectOffice(point.InfosPointRelais, transporteur);
							if(!jQuery("#shipping_method").length){
								jQuery(this).closest("form").prepend('<input type="hidden" id="shipping_method" name="shipping_method_title">');
							}
							jQuery("#shipping_method").val(transporteur);
							return false;
						});
						i++;
					});
					if(i > 1){
						map.fitBounds(bounds);
					}
				});
			}
		});
});

// Update shipping address if "Point relais" selected
function selectOffice(info, transporteur){
	if(jQuery(".woocommerce-checkout").length){
		jQuery("html, body").animate({
			scrollTop: jQuery("#customer_details .col-2:first").offset().top
	        }, 1000);
	}else{
		jQuery("html, body").animate({
			scrollTop: jQuery(".entry-title").offset().top
	        }, 1000);
	}
	jQuery('.account-form--relay .shipping_address .form-row:not(.form-row-first, .form-row-last)').addClass('form-row--disabled');
	jQuery(".show-ekan-block").show();
	jQuery(".ekan-block").hide();
	jQuery("label.ship-to-office-radio").trigger("click")
	jQuery(".checkout .shipping_address .woocommerce-shipping-fields__field-wrapper").show();
	if(jQuery('input[name="shipping_first_name"]').val() == ""){
		jQuery('input[name="shipping_first_name"]').val(jQuery("#billing_first_name").val());
	}
	if(jQuery('input[name="shipping_last_name"]').val() == ""){
		jQuery('input[name="shipping_last_name"]').val(jQuery("#billing_last_name").val());
	}
	if(jQuery('.account-form--relay input[name="shipping_address_2"]').val() == ""){
		jQuery('.account-form--relay input[name="shipping_address_2"]').closest('#shipping_address_2_field').hide();
	}
	var street1 = "";
	var street2 = "";
	if("string" == typeof info.adresse1){
		if(street1 == ""){
			street1 += " " + info.adresse1;
		}else{
			street2 += " " + info.adresse1;
		}
	}
	if("string" == typeof info.adresse2){
		if(street1 == ""){
			street1 += " " + info.adresse2;
		}else{
			street2 += " " + info.adresse2;
		}
	}
	if("string" == typeof info.adresse3){
		if(street1 == ""){
			street1 += " " + info.adresse3;
		}else{
			street2 += " " + info.adresse3;
		}
	}
	if("string" == typeof info.adresse4){
		if(street1 == ""){
			street1 += " " + info.adresse4;
		}else{
			street2 += " " + info.adresse4;
		}
	}
	street1 = street1.trim();
	street2 = street2.trim();
	jQuery('input[name="shipping_company"]').val(
		info.typePointRelais +
		" N°" + info.numeroPointRelais +
		", " + info.nom);

	jQuery('input[name="shipping_address_1"]').val(street1);
	jQuery('input[name="shipping_address_2"]').val(street2);
	jQuery('input[name="shipping_city"]').val(info.ville);
	jQuery('input[name="shipping_postcode"]').val(info.codePostal);
	jQuery("#shipping_method label:contains('" + transporteur + "')").prev("input").prop("checked", true).closest("li").show();
	jQuery('input[name="shipping_postcode"]').trigger("keydown");
	showOfficeAddress();
}
function showOfficeAddress(){
	jQuery('input[name="shipping_address_1"]').attr("autocomplete", "nope");
	if(jQuery("#shipping_method li:visible").length > 1){
		jQuery("#shipping_method").removeClass("hide-radio");
	}else{
		jQuery("#shipping_method").addClass("hide-radio");
	}
	if(!jQuery("#shipping_method li:visible input:checked").length){
		jQuery("#shipping_method li:visible input").first().click();
	}
	if(!jQuery("#ship-to-office-radio").is(":checked")){
		return;
	}
	var address = "";
	if(jQuery('input[name="shipping_address_1"]').val() != ''){
		if(address){
			address += ", ";
		}
		address += jQuery('input[name="shipping_address_1"]').val();
	}
	if(jQuery('input[name="shipping_address_2"]').val() != ''){
		if(address){
			address += ", ";
		}
		address += jQuery('input[name="shipping_address_2"]').val();
	}
	if(jQuery('input[name="shipping_city"]').val() != ''){
		if(address){
			address += ", ";
		}
		address += jQuery('input[name="shipping_city"]').val();
	}
	if(jQuery("#shipping_method input:checked + label .office-address").length){
		if(jQuery("#shipping_method input:checked + label .office-address").text() != address){
			jQuery("#shipping_method input:checked + label .office-address").text(address);
		}
		return;
	}
	jQuery("<div></div>", {
		class: "office-address"
	}).appendTo("#shipping_method input:checked + label");
}
function autocomplite(){
	if(jQuery("#address").val() == ""){
		jQuery("#address-button").attr('disabled', 'disabled');
		jQuery("#autocompleteresults").remove();
		jQuery("#address").data("place_id", "");
		return;
	}
	if(jQuery("#address").val() == jQuery("#address").data("val")){
		return;
	}
	jQuery("#address").data("place_id", "");
	// jQuery("#address").data("val", jQuery("#address").val());
	AutocompleteService.getPredictions({
		input: jQuery("#address").val(),
		componentRestrictions: {country: ['fr', 'es', 'be', 'lu']}
	}, displaySuggestions);
}
function initAutocomplete() {
	AutocompleteService = new google.maps.places.AutocompleteService();
}
function displaySuggestions(predictions, status) {
	jQuery("#autocompleteresults").remove();
	jQuery("#address-button").attr('disabled', 'disabled');
	if (status != google.maps.places.PlacesServiceStatus.OK) {
		return;
	}
	jQuery("<ul></ul>", {
		id: "autocompleteresults"
	}).insertAfter("#address");
	predictions.forEach(function(prediction){
		if(!prediction.place_id){
			return;
		}
		jQuery("<li></li>").appendTo("#autocompleteresults");
		jQuery("<a></a>", {
			href: "#"
		}).appendTo("#autocompleteresults li:last").text(prediction.description).data("place_id", prediction.place_id).click(function(){
			jQuery("#address").data("place_id", jQuery(this).data("place_id"));
			jQuery("#address").val(jQuery(this).text());
			jQuery("#address").data("val", jQuery(this).text());
			jQuery("#autocompleteresults").remove();
			jQuery("#address-button").removeAttr("disabled");
			return false;
		});
	});
};

function ekan(){
	map = null;
	markers = [];
	jQuery("#table-holder").empty();
	jQuery(".ekan-block-bottom").hide();
	if(!jQuery("#billing_address_1").length || !jQuery("#ship-to-same-address-radio").is(":checked") && jQuery("#shipping_address_1").val()){
		var address = jQuery("#shipping_address_1").val();
	}else{
		var address = jQuery("#billing_address_1").val();
	}
	if(!jQuery("#billing_city").length || !jQuery("#ship-to-same-address-radio").is(":checked") && jQuery("#shipping_city").val()){
		address += ", " + jQuery("#shipping_city").val();
	}

	jQuery("#address").focus();
	autocomplite();
}
function unekan(){
	jQuery(".ekan-block").hide();
	jQuery(".show-ekan-block").hide();
	if(jQuery(".woocommerce-checkout #shipping_method li input:checked + label:contains('Relais')," +
		".woocommerce-checkout #shipping_method li input:checked + label:contains('Mondial Relay')," +
		".woocommerce-checkout #shipping_method li input:checked + label:contains('Bureau de Poste')," +
		".woocommerce-checkout #shipping_method li input:checked + label:contains('Colissimo Commerçant')").length){
		jQuery("#shipping_method input").first().prop("checked", true);
	}
	jQuery(".woocommerce-MyAccount-content .woocommerce-address-fields input[type=text], .checkout .shipping_address input[type=text]").val("");
	jQuery(".checkout .shipping_address .woocommerce-shipping-fields__field-wrapper").show("normal");
}
jQuery(document).ready(function(){
	jQuery(".show-ekan-block").on( "click", function(e) {
		e.preventDefault();
		clearShippingDatas();

		ekan();

		jQuery('.ekan-block').show();
		jQuery('.woocommerce-shipping-fields__field-wrapper').hide();
		jQuery(this).hide();
		jQuery("html, body").animate({
			scrollTop: jQuery("#customer_details .col-2:first").offset().top
					}, 1000);
	});
	jQuery("#ship-to-different-address-radio,#ship-to-same-address-radio").click(function(){
		unekan();
	});
	jQuery("input.ship_to_different_address").click(function(){
		if(jQuery(this).val() == "1"){
			jQuery("#ship-to-different-address input").prop("checked", false).trigger("click");
		}else{
			jQuery("#ship-to-different-address input").prop("checked", true).trigger("click");
		}
		jQuery(this).closest("form")
			.removeClass("ship-to-same-address-radio ship-to-different-address-radio ship-to-office-radio")
			.addClass(jQuery(this).attr("id"));
		if(jQuery("#shipping_country:visible").length){
			jQuery("#shipping_country").select2();
		}
	});
	if(jQuery("input.ship_to_different_address:checked").val() == "1"){
		jQuery("#ship-to-different-address input").prop("checked", false).trigger("click");
	}else{
		jQuery("#ship-to-different-address input").prop("checked", true).trigger("click");
	}
	jQuery("input.ship_to_different_address")
		.closest("form")
		.addClass(jQuery("input.ship_to_different_address:checked").attr("id"));
	jQuery("#ship-to-office-radio").click(function(){
		clearShippingDatas();

		jQuery(".checkout .shipping_address .woocommerce-shipping-fields__field-wrapper").hide();
		jQuery(".checkout .shipping_address .ekan-block").show();
		jQuery(".checkout .shipping_address .show-ekan-block").hide();
		ekan();
	});
	jQuery("#shipping_company,#shipping_address_1,#shipping_address_2,#shipping_city,#shipping_postcode").change(function(){
		if(!jQuery("#shipping_method").length){
			jQuery(this).closest("form").prepend('<input type="hidden" id="shipping_method" name="shipping_method_title">');
		}
		jQuery("input#shipping_method").val("GLS Domicile");
	});
	jQuery('input[name="ship-to"]').click(function(){
		if(jQuery(this).attr("id") == "ship-to-office-radio"){
			if(!jQuery(this).closest("form").find("input[name=via_office]").length){
				jQuery("<input />", {
					type: "hidden",
					name: "via_office",
					value: 1
				}).prependTo(jQuery(this).closest("form"));
			}
		}else{
			jQuery(this).closest("form").find("input[name=via_office]").remove();
		}
	});
	var hShowOfficeAddress;
	jQuery("#order_review").bind("DOMSubtreeModified", function(){
		clearTimeout(hShowOfficeAddress);
		hShowOfficeAddress = setTimeout(function(){
			showOfficeAddress();
		}, 1000);
	});
	showOfficeAddress();
	jQuery("a.unblock").click(function(){
		var order_id = jQuery(this).attr("href").replace("#", "");
		jQuery.post(ajax.ajaxurl, {
			action: "unblock",
			order_id: order_id
		}, function(data){
			jQuery("a.unblock[href='#" + data + "']").remove();
		});
		return false;
	});
});
/* /ekan */
/* rotate360 */
	var h360;
function stop360(){
	clearInterval(h360);
	h360 = false;
}
function rotate360(parent){
	if(h360){
		stop360();
		return;
	}
	right360(parent);
	h360 = setInterval(function(){
		right360(parent);
	}, 200);
}
function right360(parent){
	if(jQuery(parent + ".img360.active").prev(".img360").length){
		jQuery(parent + ".img360.active").removeClass("active").prev(".img360").addClass("active");
	}else{
		jQuery(parent + ".img360.active").removeClass("active");
		jQuery(parent + ".img360").last().addClass("active");
	}
}
function left360(parent){
	if(jQuery(parent + ".img360.active").next(".img360").length){
		jQuery(parent + ".img360.active").removeClass("active").next(".img360").addClass("active");
	}else{
		jQuery(parent + ".img360.active").removeClass("active");
		jQuery(parent + ".img360").first().addClass("active");
	}
}
function zoomin360(parent){
	var k = jQuery(parent + ".modal360-container").data("k");
	k = parseInt(k);
	if(k >= 300){
		return;
	}
	k *= 1.25;
	jQuery(parent + ".modal360-container").data("k", k);
	jQuery(parent + ".modal360-container").css({
		width: k + '%',
		height: k + '%'
	});
}
function zoomout360(parent){
	var k = jQuery(parent + ".modal360-container").data("k");
	k = parseInt(k);
	if(k <= 80){
		return;
	}
	k *= .8;
	jQuery(parent + ".modal360-container").data("k", k);
	jQuery(parent + ".modal360-container").css({
		width: k + '%',
		height: k + '%'
	});
}
function drag360(ui){
	if(jQuery(ui.helper[0]).parent().innerWidth() > ui.helper[0].clientWidth){
		ui.position.left = 0;
	}else if(ui.position.left > 0){
		ui.position.left = 0;
	}else if(ui.position.left < jQuery(ui.helper[0]).parent().innerWidth() - ui.helper[0].clientWidth){
		ui.position.left = jQuery(ui.helper[0]).parent().innerWidth() - ui.helper[0].clientWidth;
	}
	if(jQuery(ui.helper[0]).parent().innerHeight() > ui.helper[0].clientHeight){
		ui.position.top = 0;
	}else if(ui.position.top > 0){
		ui.position.top = 0;
	}else if(ui.position.top < jQuery(ui.helper[0]).parent().innerHeight() - ui.helper[0].clientHeight){
		ui.position.top = jQuery(ui.helper[0]).parent().innerHeight() - ui.helper[0].clientHeight;
	}
}
jQuery(document).ready(function(){
	jQuery(".button360").click(function(){
		var id = jQuery(this).data("id");
		jQuery(".div360, .close360").remove();
		stop360();
		jQuery("<a></a>", {
			class: "close360",
			href: "#"
		}).appendTo(".woocommerce-product-gallery").click(function(){
			jQuery(".div360, .close360, .popup360").remove();
			stop360();
			return false;
		});
		jQuery("<a></a>", {
			class: "popup360",
			href: "#"
		}).appendTo(".woocommerce-product-gallery").click(function(){
			stop360();
			var id = jQuery(this).data("id");
			jQuery(".modal360, .modal360-bg").remove();
			stop360();
			jQuery("<div></div>", {
				class: "modal360-bg"
			}).appendTo("body").click(function(){
				jQuery(".modal360, .modal360-bg").remove();
				stop360();
			});
			jQuery("<div></div>", {
				class: "modal360"
			}).appendTo("body");
			jQuery("<a></a>", {
				class: "close360",
				href: "#"
			}).appendTo("body > .modal360").click(function(){
				jQuery(".modal360, .modal360-bg").remove();
				stop360();
				return false;
			});
			jQuery("<div></div>", {
				class: "modal360-container"
			}).appendTo("body > .modal360").data("k", 100).draggable({
				drag: function(event, ui){
					stop360();
					drag360(ui);
				}
			});
			jQuery("<div></div>", {
				class: "modal360-buttons"
			}).appendTo("body > .modal360");
			jQuery("<a></a>", {
				href: "#",
				class: "left"
			}).appendTo(".modal360 .modal360-buttons").click(function(){
				stop360();
				left360(".modal360 ");
				return false;
			});
			jQuery("<a></a>", {
				href: "#",
				class: "right"
			}).appendTo(".modal360 .modal360-buttons").click(function(){
				stop360();
				right360(".modal360 ");
				return false;
			});
			jQuery("<a></a>", {
				href: "#",
				class: "zoomin"
			}).appendTo(".modal360 .modal360-buttons").click(function(){
				stop360();
				zoomin360(".modal360 ");
				return false;
			});
			jQuery("<a></a>", {
				href: "#",
				class: "zoomout"
			}).appendTo(".modal360 .modal360-buttons").click(function(){
				stop360();
				zoomout360(".modal360 ");
				return false;
			});
			jQuery("<a></a>", {
				href: "#",
				class: "rotate"
			}).appendTo(".modal360 .modal360-buttons").click(function(){
				rotate360(".modal360 ");
				return false;
			});
			for(var i = 0; i < 24; i++){
				if(!i){
					var active = " active";
				}else{
					var active = "";
				}
				jQuery("<img />", {
					class: "img360" + active,
					src: "/react/object2vr/output/" + id + "/img_0_0_" + i + ".jpg"
				}).appendTo(".modal360 .modal360-container");
			}
			return false;
		}).data("id", id);
		jQuery("<div></div>", {
			class: "div360"
		}).appendTo(".woocommerce-product-gallery");
		jQuery("<div></div>", {
			class: "modal360-container"
		}).appendTo(".div360").data("k", 100).draggable({
			drag: function(event, ui){
				stop360();
				drag360(ui);
			}
		});
		jQuery("<div></div>", {
			class: "modal360-buttons"
		}).appendTo(".div360");
		jQuery("<a></a>", {
			href: "#",
			class: "left"
		}).appendTo(".modal360-buttons").click(function(){
			stop360();
			left360(".div360 ");
			return false;
		});
		jQuery("<a></a>", {
			href: "#",
			class: "right"
		}).appendTo(".modal360-buttons").click(function(){
			stop360();
			right360(".div360 ");
			return false;
		});
		jQuery("<a></a>", {
			href: "#",
			class: "zoomin"
		}).appendTo(".modal360-buttons").click(function(){
			stop360();
			zoomin360(".div360 ");
			return false;
		});
		jQuery("<a></a>", {
			href: "#",
			class: "zoomout"
		}).appendTo(".modal360-buttons").click(function(){
			stop360();
			zoomout360(".div360 ");
			return false;
		});
		jQuery("<a></a>", {
			href: "#",
			class: "rotate"
		}).appendTo(".modal360-buttons").click(function(){
			rotate360(".div360 ");
			return false;
		});
		for(var i = 0; i < 24; i++){
			if(!i){
				var active = " active";
			}else{
				var active = "";
			}
			jQuery("<img />", {
				class: "img360" + active,
				src: "/react/object2vr/output/" + id + "/img_0_0_" + i + ".jpg"
			}).appendTo(".modal360-container");
		}
		//rotate360();
		return false;
	});
});
/* /rotate360 */
/* tta */
jQuery(document).ready(function(){
	jQuery("<a></a>", {
		href: "#",
		class: "tta-left"
	}).appendTo(".vc_tta").click(function(){
		if(jQuery(this).parent().find(".vc_pagination .vc_active").prev("li").length){
			jQuery(this).parent().find(".vc_pagination .vc_active").prev("li").find("a").click();
		}else{
			jQuery(this).parent().find(".vc_pagination li:last a").click();
		}
		return false;
	});
	jQuery("<a></a>", {
		href: "#",
		class: "tta-right"
	}).appendTo(".vc_tta").click(function(){
		if(jQuery(this).parent().find(".vc_pagination .vc_active + li").length){
			jQuery(this).parent().find(".vc_pagination .vc_active + li a").click();
		}else{
			jQuery(this).parent().find(".vc_pagination li:first a").click();
		}
		return false;
	});
});
/* /tta */
/* product */
jQuery(document).ready(function(){
	function check_qty(){
		var disabled = true;
		jQuery(".variation input[type=number]").each(function(){
			if(parseInt(jQuery(this).val())){
				disabled = false;
			}
			if(disabled){
				jQuery(".variations .single_add_to_cart_button").addClass("disabled");
			}else{
				jQuery(".variations .single_add_to_cart_button").removeClass("disabled");
			}
		});
	}
	jQuery(".variation input[type=number]").change(function(){
		check_qty();
	});
	check_qty();
});
/* /product */
/* product-list */
jQuery(document).ready(function(){
	jQuery(".variation input[type=radio]").click(function(){
		jQuery(this).next("label").find("input").prop("checked", true);
	});
});

/* /product-list */
/* checkout */
jQuery(document).ready(function(){
	if(jQuery("#shipping_country:not('.select2-hidden-accessible'):visible").length){
		jQuery("#shipping_country:not('.select2-hidden-accessible'):visible").select2();
	}
	jQuery(".account-form").hide().find('.validate-required').addClass('woocommerce-disable-validate woocommerce-validated').removeClass('validate-required woocommerce-invalid woocommerce-invalid-required-field').find('input').attr({formnovalidate: 'formnovalidate'});
	jQuery(".choices__item label").click(function(){
		if(jQuery(this).hasClass('shipping-form-label')) {
			jQuery('.shipping_address').detach().appendTo(jQuery(this).next('.account-form'));
			jQuery('#shipping_address_2_field').show();
			jQuery('input#shipping_address_2').show();
		}
		jQuery(this).closest(".choices__item").siblings().find(".account-form").slideUp().find('.validate-required').addClass('woocommerce-disable-validate woocommerce-validated').removeClass('validate-required woocommerce-invalid woocommerce-invalid-required-field').find('input').attr({formnovalidate: 'formnovalidate'});
		jQuery(this).next(".account-form").slideDown().find('.woocommerce-disable-validate').addClass('validate-required').removeClass('woocommerce-disable-validate woocommerce-validated').find('input').removeAttr('formnovalidate');
	});
	if(jQuery("#gift_package").prop("checked")){
		jQuery("#gift_package").closest("label").addClass("checked");
	}
	jQuery("#gift_package").click(function(){
		if(jQuery(this).prop("checked")){
			jQuery(this).closest("label").addClass("checked");
		}else{
			jQuery(this).closest("label").removeClass("checked");
		}
	});
	jQuery("form.checkout").bind("DOMSubtreeModified", function(){
		jQuery(this).find(".woocommerce-NoticeGroup-checkout").prependTo(jQuery(this).closest(".woocommerce"));
	});
});
/* /checkout */
/* design */
jQuery(document).ready(function(){
	jQuery(".woocommerce-products-header").bind("DOMSubtreeModified", function(){
		read_more();
	});
	read_more();
function read_more(){
	jQuery(".more").click(function(){
		jQuery(this).closest(".term-short-description").hide().parent().find(".term-long-description").show();
		return false;
	});
	jQuery(".read-less").click(function(){
		jQuery(this).closest(".term-long-description").hide().parent().find(".term-short-description").show();
		return false;
	});
}
// Select all links with hashes
jQuery('a[href*="#"]')
  .not(".vc_pagination-trigger,[href^='#tab-']")
  // Remove links that don't actually link to anything
  .not('[href="#"]')
  .not('[href="#0"]')
  .click(function(event) {
    // On-page links
    if (
      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
      &&
      location.hostname == this.hostname
    ) {
      // Figure out element to scroll to
      var target = jQuery(this.hash);
      target = target.length ? target : jQuery('[name=' + this.hash.slice(1) + ']');
      // Does a scroll target exist?
      if (target.length) {
        // Only prevent default if animation is actually gonna happen
        event.preventDefault();
        jQuery('html, body').animate({
          scrollTop: target.offset().top
        }, 1000, function() {
          // Callback after animation
          // Must change focus!
          var $target = jQuery(target);
          $target.focus();
          if ($target.is(":focus")) { // Checking if the target was focused
            return false;
          } else {
            $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
            $target.focus(); // Set focus again
          };
        });
      }
    }
  });
});
/* /design */

function wcqib_refresh_quantity_increments() {
	jQuery("div.quantity:not(.buttons_added), td.quantity:not(.buttons_added)").each(function(a, b) {
			var c = jQuery(b);
			c.addClass("buttons_added"), c.children().first().before('<input type="button" value="—" class="minus number-btn" />'), c.children().last().after('<input type="button" value="+" class="plus number-btn" />')
	})
}
String.prototype.getDecimals || (String.prototype.getDecimals = function() {
	var a = this,
			b = ("" + a).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
	return b ? Math.max(0, (b[1] ? b[1].length : 0) - (b[2] ? +b[2] : 0)) : 0
}), jQuery(document).ready(function() {
	wcqib_refresh_quantity_increments()
}), jQuery(document).on("updated_wc_div", function() {
	wcqib_refresh_quantity_increments()
}), jQuery(document).on("click", ".plus, .minus", function() {
	var a = jQuery(this).closest(".quantity").find(".qty"),
			b = parseFloat(a.val()),
			c = parseFloat(a.attr("max")),
			d = parseFloat(a.attr("min")),
			e = a.attr("step");
	b && "" !== b && "NaN" !== b || (b = 0), "" !== c && "NaN" !== c || (c = ""), "" !== d && "NaN" !== d || (d = 0), "any" !== e && "" !== e && void 0 !== e && "NaN" !== parseFloat(e) || (e = 1), jQuery(this).is(".plus") ? c && b >= c ? a.val(c) : a.val((b + parseFloat(e)).toFixed(e.getDecimals())) : d && b <= d ? a.val(d) : b > 0 && a.val((b - parseFloat(e)).toFixed(e.getDecimals())), a.trigger("change")
});


(function ($) {
	jQuery( "body" ).on( "init_checkout", function() {
		window.setTimeout(function() {
			// Empty point relais address field on page loading
			jQuery('#address').val('');

			clearShippingDatas();

			if(jQuery('.ship-to-office-radio').hasClass('shipping-form-label')) {
				jQuery('.shipping_address').detach().appendTo(jQuery('.ship-to-office-radio').next('.account-form'));
			}
			jQuery('.ship-to-office-radio').closest(".choices__item").siblings().find(".account-form").slideUp().find('.validate-required').addClass('woocommerce-disable-validate woocommerce-validated').removeClass('validate-required woocommerce-invalid woocommerce-invalid-required-field').find('input').attr({formnovalidate: 'formnovalidate'});
			jQuery('.ship-to-office-radio').next(".account-form").slideDown().find('.woocommerce-disable-validate').addClass('validate-required').removeClass('woocommerce-disable-validate woocommerce-validated').find('input').removeAttr('formnovalidate');

			ekan();

			jQuery("#ship-to-office-radio").trigger('click');
		}, 150)
	});

	// Account create on submit
	$("form.checkout").on("submit", function(e){
		e.preventDefault();
		$('#account_username_hidden').val($('#account_username').val());
		$('#account_password_hidden').val($('#account_password').val());
	});

	// Mobile facets reveal
	$('.facet-display-btn').on('click', function() {
		if ($('.facet-filters').hasClass('active')) {
			$('.facet-filters').slideUp();
			$('.facet-filters').removeClass('active');
			$(this).text('Afficher les filtres');
		} else {
			$('.facet-filters').slideDown();
			$('.facet-filters').addClass('active');
			$(this).text('Masquer les filtres');
		}
	});

	// Update cart on quantity change
	if ($('body').hasClass('woocommerce-cart')) {
		let timeout;
		$('.woocommerce').on('change', 'input.qty', function(){
			if ( timeout !== undefined ) {
				clearTimeout( timeout );
			}
			timeout = setTimeout(function() {
				$("[name='update_cart']").trigger("click"); // trigger cart update
			}, 1000 );
		});
	}

})(jQuery);
